import { FormFields } from '../../../types'
import {
  areEquals,
  isValidEmail,
  isValidPassword,
} from '../DynamicFields/Validations'

export const credentialsFields = ({
  state,
  isNewUser,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state: any
  isNewUser: boolean
}): FormFields[] => {
  return [
    !isNewUser && {
      title: 'Ingresa tus credenciales actuales para confirmar los cambios',
      type: 'doubleColums',
      rowLeft: [
        {
          type: 'password',
          label: 'Contraseña actual*',
          placeholder: state.currentPassword,
          id: 'currentPassword',
          value: state.currentPassword,
          validation: {
            validate: isValidPassword,
            message: 'No es un email válido.',
          },
          isMandatory: true,
          inputClass: 'content-password',
        },
      ],
      rowRight: [
        {
          type: 'email',
          label: 'Email actual*',
          placeholder: state.currentEmail,
          id: 'currentEmail',
          value: state.currentEmail,
          validation: {
            validate: isValidEmail,
            message: 'No es un email válido.',
          },
          isMandatory: true,
        },
      ],
    },
    {
      title: ' Ingresa tus nuevas credenciales',
      type: 'doubleColums',
      rowLeft: [
        {
          type: 'password',
          label: `${!isNewUser ? 'Nueva ' : ''}Contraseña`,
          placeholder: state.password,
          id: 'password',
          value: state.password,
          validation: {
            validate: isValidEmail,
            message: 'No es un email válido.',
          },
          isMandatory: true,
          inputClass: 'content-password',
        },
        {
          type: 'password',
          label: `Confirmar ${!isNewUser ? 'nueva ' : ''}contraseña`,
          placeholder: state.confirmPassword,
          id: 'confirmPassword',
          value: state.confirmPassword,
          validation: {
            validate: areEquals(state.password),
            message: 'Los contraseñas no coinciden',
          },
          isMandatory: true,
          inputClass: 'content-password',
        },
      ],
      rowRight: [
        {
          type: 'email',
          label: `${!isNewUser ? 'Nuevo ' : ''}Email`,
          placeholder: state.email,
          id: 'email',
          value: state.email,
          validation: {
            validate: isValidEmail,
            message: 'No es un email válido.',
          },
          isMandatory: true,
        },
        {
          type: 'email',
          label: `Confirmar ${!isNewUser ? 'nuevo ' : ''}email`,
          placeholder: state.confirmEmail,
          id: 'confirmEmail',
          value: state.confirmEmail,
          validation: {
            validate: areEquals(state.email),
            message: 'Los emails no coinciden',
          },
          isMandatory: true,
        },
      ],
    },
  ].filter(Boolean) as FormFields[]
}
